module.exports = __webpack_public_path__ + "img/logo.ee62cd69.png";